module.exports = __webpack_public_path__ + "static/media/20190826_193511[1].image.e0bdf70b.png";